<template>
  <div class="center_box">
    <div class="center_content">
      <div class="content_left">
        <div class="user_info">
          <img
            v-if="userInfo.avatar_url" v-lazy="userInfo.avatar_url" alt="avatar"
            class="user_avatar">
          <div v-else class="user_avatar" />
          <h5 class="user_name ellipsis_one">{{ userInfo.username }}</h5>
          <p class="user_id ellipsis_one">ID:{{ userInfo.uid }}</p>
        </div>
        <ul class="center_nav">
          <li class="nav_item"><router-link class="item_link" to="/center/" @click.native="report(1)">我的购买</router-link></li>
          <!-- <li class="nav_item"><router-link class="item_link" to="/center/collect">我的收藏</router-link></li> -->
          <li class="nav_item"><router-link class="item_link" to="/center/downLoad" @click.native="report(2)">我的下载</router-link></li>
        </ul>
      </div>
      <div class="content_right"><router-view /></div>
    </div>
  </div>
</template>

<script>
import { reportLoad, reportAction } from '@/report/index.js'

export default {
  name: 'Center',

  computed: {
    userInfo () {
      return this.$store.state.userInfo
    },
    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    }
  },

  watch: {
    isLoginedIn (flag) {
      if (!flag) {
        window.open('/', '_self')
      }
    }
  },

  mounted () {
    reportLoad({ pagetype: 5 })
  },

  methods: {
    report (area) {
      reportAction({ actiontype: 2, area, pos: '' })
    },

  },
}
</script>

<style lang="scss" scoped>
.center_box { height: 100%; min-height: 637px; background-image: url(~@/assets/images/bg_home_top.png); background-repeat: no-repeat; background-position: 0 -190px; background-size: 100%;
  @media (max-width: 1800px) {
    .center_content { max-width: 1250px; }
    .content_right { max-width: 1022px; }
  }

  .center_content { width: $default_content_width; height: 100%; padding-top: 38px; margin: auto; overflow: hidden; }
  .content_left { float:left; width: 200px; }
  .user_info { padding: 60px 10px; margin-bottom: 40px; font-size: 14px; line-height: 14px; text-align: center; background-color: #fff; border-radius: 8px; }
  .user_avatar { width: 100px; height: 100px; margin: 0px auto 32px auto; background-color: #3363FF; border-radius: 50%; }
  .user_name { margin-bottom: 25px; font-weight: 400; line-height: 14px; color: #333; }
  .user_id { color: #666; }

  .center_nav { padding: 28px 0; background-color: #fff; border-radius: 8px; }
  .nav_item { position: relative; height: 60px; font-size: 16px; font-weight: 500; line-height: 60px; text-align: center; cursor: pointer;
    &+.nav_item { margin-top: 11px; }
  }
  .item_link { display: inline-block; width: 100%; height: 100%; color: #666; text-decoration: none;
    &.router-link-exact-active { color: $default_primary_hover; background-color: #ebf0ff;
      &::before { position: absolute; left: 0; width: 4px; height: 100%; content: ''; background-color: $default_primary_color; border-radius: 2px; }
    }
  }

  .content_right { width: 1300px; min-height: 604px; margin-bottom: 30px; margin-left: 228px; font-size: 16px; font-weight: 500; color: #333; background-color: #fff; border-radius: 8px; }
}
</style>
